import React, { useState } from 'react';
import { v4 } from 'uuid';
import Dialog from 'components/shared/Dialog';

function LockUnlockConfirmDialog({ open, title, description, actions }) {
  const [titleId] = useState(() => v4());

  return (
    <Dialog role="alertdialog" aria-labelledby={titleId} open={open}>
      <Dialog.Container maxWidth={560}>
        <Dialog.Title id={titleId}>{title}</Dialog.Title>
        {description && <Dialog.Content>{description}</Dialog.Content>}
        <Dialog.Actions>{actions}</Dialog.Actions>
      </Dialog.Container>
    </Dialog>
  );
}

export default LockUnlockConfirmDialog;
